export const SETTING_TABS_CONST = {
  teamManagement: { label: "Gestion équipe", tabId: "gestion-equipe" },
  maintenance: { label: "Maintenance", tabId: "gestion-maintenance" },
  companyConfig: { label: "Sociétés", tabId: "gestion-societes" },
  autres: { label: "Autres", tabId: "autres" },
};
